import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { CourseService } from 'src/app/service/course.service';
import { EsercitazioneService } from '../../../service/esercitazione.service';
import { first } from 'rxjs/operators';
import { CorsoModulo } from '../../../model/corsomodulo';
import { ModuloService } from 'src/app/service/modulo.service';
import { UserEsercitazione } from 'src/app/model/esercitazione/useresercitazione';
import { Corso } from 'src/app/model/corso';
import { CourseService } from 'src/app/service/course.service';
// import { Corso } from 'src/app/model/corso';

@Component({
  selector: 'app-esercitazioni-archivio',
  templateUrl: './esercitazioni-archivio.component.html',
  styleUrls: ['./esercitazioni-archivio.component.css']
})
export class EsercitazioniArchivioComponent implements OnInit {

    corso: Corso;
    modulo: CorsoModulo;
    esercitazioni: Array<UserEsercitazione>;
    moduloParentsStruct: Array<CorsoModulo>;

    constructor(
        private route: ActivatedRoute,
        private corsoSrv: CourseService,
        private moduloSrv: ModuloService,
        private esercitazioneSrv: EsercitazioneService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params =>  {
            const moduloId = +params.get('moduloId');
            this.loadCorso(+params.get('courseId'));
            this.loadModulo(moduloId);
            this.loadModuloParentsStruct(moduloId);
            this.loadArchiveEsercitazioni(moduloId);
        });
    }

    private loadArchiveEsercitazioni(moduloId: number) {
        this.esercitazioneSrv.loadArchiveEsercitazione(moduloId)
        .pipe(first())
        .subscribe(
            data => {
                this.esercitazioni = data;
            },
            error => {
                return;
            }
        );
    }

    private loadCorso(courseId: number) {
        this.corsoSrv.getCourse(courseId)
        .pipe(first())
            .subscribe(
                data => {
                    this.corso = data;
                },
                error => {
                    return;
                }
            );
    }

    private loadModulo(moduloId: number) {
        this.moduloSrv.getModuloCertificazione(moduloId)
        .pipe(first())
        .subscribe(
            data => {
                this.modulo = data;
            },
            error => {
                return;
            }
        );
    }

    private loadModuloParentsStruct(moduloId: number) {
        this.moduloSrv.getModuleParentsStruct(moduloId)
        .pipe(first())
            .subscribe(
                data => {
                    this.moduloParentsStruct = data;
                },
                error => {
                    return;
                }
            );
    }

}
